<template>
  <div v-loading="loading">
    <FormBox :title="$t('message.DataRegistration.formData.owner_data')" style="background:#fff;">
      <el-form
        ref="ruleForm"
        :model="form.quota"
        class="form_type1_box"
        :rules="quotaRules"
        hide-required-asterisk
      >
        <el-row :gutter="86">
          <!-- SP查詢編號 -->
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.spNo')">
              <el-input v-model="verifyForm.spNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- PERSON -->
        <div v-if="applicantType == 'PERSON'">
          <el-row :gutter="86">
            <!-- 配額人的證件類別 -->
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('message.DataRegistration.Quota.idType')"
                prop="personIdentityType"
              >
                <el-select
                  v-model="form.quota.personIdentityType"
                  value-key="codeKey"
                  filterable
                  disabled
                >
                  <!-- :label="item[`name${$t('message.lan')}`]" -->
                  <el-option
                    v-for="item in idType"
                    :key="item.codeKey"
                    :label="item[`${$t('message.codeName')}`]"
                    :value="item.codeKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 配額人的澳門居民身份證編號 -->
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('message.DataRegistration.Quota.personIdentityNo')">
                <el-input
                  v-model="form.quota.personIdentityNo"
                  :placeholder="$t('message.DataRegistration.Quota.personIdentityNo_plh')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="86">
            <!-- 配額人的中文姓名 -->
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('message.DataRegistration.Quota.personNameCn')"
                prop="personNameCn"
              >
                <el-input
                  v-model="form.quota.personNameCn"
                  :placeholder="applicationType != 'RENEW' ? $t('message.DataRegistration.Quota.personNameCn_plh') : ''"
                  :disabled="applicationType == 'RENEW'"
                  @input="inputToUpperCase($event, 'personNameCn')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 配額人的外文姓名 -->
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('message.DataRegistration.Quota.personNameEn')"
                prop="personNameEn"
              >
                <el-input
                  v-model="form.quota.personNameEn"
                  :placeholder="applicationType != 'RENEW' ? $t('message.DataRegistration.Quota.personNameEn_plh') : ''"
                  :disabled="applicationType == 'RENEW'"
                  @input="inputToUpperCase($event, 'personNameEn')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="86">
            <!-- 配額人的出生日期 -->
            <el-col :xs="24" :sm="12">
              <el-form-item
                v-if="applicationType == 'FIRST'"
                :label="$t('message.DataRegistration.Quota.personBirthday')"
                prop="personBirthday"
              >
                <el-date-picker
                  v-model="form.quota.personBirthday"
                  type="date"
                  :placeholder="$t('message.DataRegistration.Quota.personBirthday_plh')"
                  :picker-options="beforeToday"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- COMPANY -->
        <div v-if="applicantType == 'COMPANY'">
          <el-row :gutter="86">
            <!-- 配額公司的商業登記類型 -->
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('message.DataRegistration.Quota.companyIdentityType')"
                prop="companyIdentityType"
              >
                <el-select
                  v-model="form.quota.companyIdentityType"
                  :placeholder="$t('message.Verification.company.macau_company_type_plh')"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="item in companyType"
                    :key="item.code"
                    :label="item.label"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 配額公司的商業登記編號 -->
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('message.DataRegistration.Quota.companyBrNo')"
                prop="companyBrNo"
              >
                <el-input
                  v-model="form.quota.companyBrNo"
                  :placeholder="$t('message.DataRegistration.Quota.companyBrNo_plh')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="86">
            <!-- 配額公司的商業登記名稱（中文） -->
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('message.DataRegistration.Quota.companyNameCn')"
                :prop="applicationType != 'RENEW' ? 'companyNameCn' : null"
              >
                <el-input
                  v-model="form.quota.companyNameCn"
                  :placeholder="applicationType == 'RENEW' ? '' : $t('message.DataRegistration.Quota.companyNameCn_plh')"
                  :disabled="applicationType == 'RENEW'"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 配額公司的商業登記名稱（外文） -->
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('message.DataRegistration.Quota.companyNameEn')"
                :prop="applicationType != 'RENEW' ? 'companyNameEn' : null"
              >
                <el-input
                  v-model="form.quota.companyNameEn"
                  :placeholder="applicationType == 'RENEW' ? '' : $t('message.DataRegistration.Quota.companyNameEn_plh')"
                  :disabled="applicationType == 'RENEW'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 選填提示 -->
          <el-row :gutter="86">
            <el-col v-if="applicationType != 'RENEW'" :xs="24" :sm="24">
              <div
                :class="`tips_red tips_red_${$i18n.locale}`"
              >{{$t('message.formRuleMessage.either_or_companyNameCn_companyNameEn')}}</div>
            </el-col>
          </el-row>
        </div>
        <!-- PUBLIC -->
        <el-row :gutter="86">
          <!-- OTHER -->
          <!-- 配額人的本澳流動電話 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              v-if="applicationType == 'FIRST'"
              :label="$t('message.DataRegistration.Quota.macauMobile')"
              prop="macauMobile"
            >
              <el-input
                v-model="form.quota.macauMobile"
                :placeholder="$t('message.DataRegistration.Quota.personal_macauMobile_plh')"
                class="input-with-select"
                maxlength="8"
              >
                <template slot="prepend">+853</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- macauAddress -->
        <!-- 配額人的澳門聯絡地址 -->
        <el-row :gutter="86">
          <el-col :span="24">
            <el-form-item
              v-if="applicationType == 'FIRST'"
              :label="$t('message.macauAddress.quotaMacauAddress')"
              prop="vssMacauAddress"
            >
              <el-radio-group v-model="form.quota.vssMacauAddress" @change="changeVssMacauAddress">
                <el-radio
                  v-if="$store.state.vssForm.spRemark && $store.state.vssForm.spRemark.applyAddress"
                  :label="$store.state.vssForm.spRemark.applyAddress"
                >{{$store.state.vssForm.spRemark.applyAddress}}</el-radio>
                <el-radio label="other">{{$t('message.self_write')}}</el-radio>
              </el-radio-group>
              <el-input
                ref="macauAddressInput"
                v-if="form.quota.vssMacauAddress == 'other' && form.quota.macauAddress.textPt"
                v-model="form.quota.macauAddress.textPt"
                :placeholder="$t('message.macauAddress.macauAddress_plh')"
                @focus="onAddressFocus"
              ></el-input>
              <el-input
                ref="macauAddressInput"
                v-if="form.quota.vssMacauAddress == 'other' && !form.quota.macauAddress.textPt"
                v-model="form.quota.macauAddress.textCn"
                :placeholder="$t('message.macauAddress.macauAddress_plh')"
                @focus="onAddressFocus"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="86">
          <!-- 配額人的內地聯絡電話 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.Quota.mainlandPhone')"
              prop="mainlandPhone"
              :class="`${
                !form.quota.mainlandEmail
                  ? 'is-required'
                  : ''
              }`"
            >
              <el-input
                v-model="form.quota.mainlandPhone"
                :placeholder="$t('message.DataRegistration.Quota.personal_mainlandPhone_plh')"
                maxlength="11"
                @input="$refs['ruleForm'].validateField(['mainlandPhone', 'mainlandEmail'])"
              >
                <template slot="prepend">+86</template>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 配額人的內地電郵地址 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.Quota.mainlandEmail')"
              prop="mainlandEmail"
              :class="`${
                !form.quota.mainlandPhone
                  ? 'is-required'
                  : ''
              }`"
            >
              <el-input
                v-model="form.quota.mainlandEmail"
                :placeholder="$t('message.DataRegistration.Quota.personal_mainlandEmail_plh')"
                @input="$refs['ruleForm'].validateField(['mainlandPhone', 'mainlandEmail'])"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="86">
          <!-- 選填提示 -->
          <el-col :xs="24" :sm="24">
            <div
              :class="`tips_red tips_red_${$i18n.locale}`"
            >{{$t('message.formRuleMessage.either_or_mainlandPhone_mainlandEmail')}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="86">
          <!-- 配額人的香港聯絡電話 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              v-if="applicationType == 'FIRST'"
              :label="$t('message.DataRegistration.Quota.hkPhone')"
              prop="hkPhone"
            >
              <el-input
                v-model="form.quota.hkPhone"
                :placeholder="$t('message.DataRegistration.Quota.personal_hkPhone_plh')"
              >
                <template slot="prepend">+852</template>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 配額人的其他聯絡電話 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              v-if="applicationType == 'FIRST'"
              :label="$t('message.DataRegistration.Quota.otherPhone')"
              prop="otherPhone"
            >
              <el-input
                v-model="form.quota.otherPhone"
                :placeholder="$t('message.DataRegistration.Quota.personal_otherPhone_plh')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="86">
          <!-- 配額人的香港聯絡地址 -->
          <el-col :xs="24" :sm="24">
            <el-form-item
              v-if="applicationType == 'FIRST'"
              :label="$t('message.DataRegistration.Quota.hkAddress')"
              prop="hkAddress"
            >
              <el-input
                v-model="form.quota.hkAddress"
                :placeholder="$t('message.DataRegistration.Quota.personal_hkAddress_plh')"
                @input="inputToUpperCase($event, 'hkAddress')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </FormBox>
    <!-- 澳門地址彈窗 -->
    <MacauAddressDialog
      :visible="showAddressDialog"
      @save="saveMacauAddress"
      @close="showAddressDialog = false;"
    ></MacauAddressDialog>
  </div>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import FormBox from "./FormBox";
import VssViewAPI from "../../../../api/VssViewAPI";
import MacauAddressDialog from "./MacauAddressDialog";
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          quota: {
            macauAddress: {},
          },
        };
      },
    },
    applicationType: String,
    applicantType: String,
  },
  components: { FormBox, MacauAddressDialog },
  data() {
    let mainlandPhoneCheck = (rule, value, callback) => {
      const { mainlandEmail } = this.form.quota;
      if (!value && !mainlandEmail) {
        // 二選一必填
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    let mainlandEmailCheck = (rule, value, callback) => {
      const { mainlandPhone } = this.form.quota;
      if(!value && !mainlandPhone) {
        // 二選一必填
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    let companyNameCnCheck = (rule, value, callback) => {
      // 驗證配額公司的商業登記名稱（中文）
      const companyNameEn = this.form.quota.companyNameEn || null;
      if (value && !companyNameEn) {
        this.quotaRules.companyNameCn[0].required = true;
        this.quotaRules.companyNameEn[0].required = false;
        this.$refs["ruleForm"].validateField("companyNameEn");
      }
      // if (value) this.$refs["ruleForm"].validateField("companyNameEn");
      if (!value && !companyNameEn) {
        this.quotaRules.companyNameCn[0].required = true;
        this.quotaRules.companyNameEn[0].required = true;
        callback(new Error(""));
      } else {
        callback();
      }
    };
    let companyNameEnCheck = (rule, value, callback) => {
      // 驗證配額公司的商業登記名稱（外文）
      const companyNameCn = this.form.quota.companyNameCn || null;
      if (value && !companyNameCn) {
        this.quotaRules.companyNameCn[0].required = false;
        this.quotaRules.companyNameEn[0].required = true;
        this.$refs["ruleForm"].validateField("companyNameCn");
      }
      // if (value) this.$refs["ruleForm"].validateField("companyNameCn");
      if (!value && !companyNameCn) {
        this.quotaRules.companyNameCn[0].required = true;
        this.quotaRules.companyNameEn[0].required = true;
        callback(new Error(""));
      } else {
        callback();
      }
    };
    let validcodeMacauMobile = (rule, value, callback) => {
      // 驗證澳門手機
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.macauMobile")));
      } else {
        callback();
      }
    };
    let olderThan18 = (rule, value, callback) => {
      const birthdays = new Date(value) || value;
      let d = new Date();
      let age = null;
      if (birthdays) {
        age =
          d.getFullYear() -
          birthdays.getFullYear() -
          (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
            ? 1
            : 0);
      }
      if (value && age < 18) {
        callback(new Error(i18n.t("message.formRuleMessage.olderThan18")));
      } else {
        callback();
      }
    };
    let macauAddressCheck = (rule,value,callback)=>{
      if (value == 'other' && !this.form.quota.macauAddress.textCn) {
        callback(new Error(i18n.t("message.formRuleMessage.notNull")));
      } else {
        callback();
      }
    }
    return {
      loading: false,
      beforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天
        },
      },
      quotaRules: {
        personNameCn: [
          {
            max: 200,
            message: i18n.t("message.formRuleMessage.maxLength200"),
            trigger: "blur",
          },
        ],
        personNameEn: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 200,
            message: i18n.t("message.formRuleMessage.maxLength200"),
            trigger: "blur",
          },
        ],
        personIdentityNo: [
          {
            max: 50,
            message: i18n.t("message.formRuleMessage.maxLength50"),
            trigger: "blur",
          },
        ],
        personBirthday: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          { validator: olderThan18, trigger: "change" },
          { validator: olderThan18, trigger: "blur" },
        ],
        companyNameCn: [
          {
            required: true,
            message: i18n.t(" "),
          },
          {
            max: 200,
            message: i18n.t("message.formRuleMessage.maxLength200"),
            trigger: "blur",
          },
          { validator: companyNameCnCheck },
        ],
        companyNameEn: [
          {
            required: true,
            message: i18n.t(" "),
          },
          {
            max: 200,
            message: i18n.t("message.formRuleMessage.maxLength200"),
            trigger: "blur",
          },
          { validator: companyNameEnCheck },
        ],
        companyBrNo: [
          {
            max: 50,
            message: i18n.t("message.formRuleMessage.maxLength50"),
            trigger: "blur",
          },
        ],
        otherPhone: [
          {
            max: 21,
            message: i18n.t("message.formRuleMessage.maxLength21"),
            trigger: "blur",
          },
          {
            pattern: /^[\d\-\,]+$/,
            message: i18n.t("message.formRuleMessage.otherPhone"),
            trigger: "blur",
          }
        ],
        hkPhone: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 26,
            message: i18n.t("message.formRuleMessage.maxLength26"),
            trigger: "blur",
          },
          {
            pattern: /^[\d\-]+$/,
            message: i18n.t("message.formRuleMessage.hkPhone"),
            trigger: "blur",
          }
        ],
        hkAddress: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 200,
            message: i18n.t("message.formRuleMessage.maxLength200"),
            trigger: "blur",
          },
        ],
        mainlandPhone: [
          { validator: mainlandPhoneCheck },
          {
            pattern: /^[\d]+$/,
            message: i18n.t("message.formRuleMessage.mainlandPhone"),
            trigger: "blur",
          },
        ],
        mainlandEmail: [
          { validator: mainlandEmailCheck },
          {
            pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/,
            message: i18n.t("message.formRuleMessage.email"),
            trigger: "blur",
          },
          {
            max: 50,
            message: i18n.t("message.formRuleMessage.maxLength50"),
            trigger: "blur",
          },
        ],
        vssMacauAddress: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "change",
          },
          { validator: macauAddressCheck }
        ],
        macauMobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          { validator: validcodeMacauMobile, trigger: "blur" },
          {
            max: 30,
            message: i18n.t("message.formRuleMessage.maxLength30"),
            trigger: "blur",
          },
        ],
      },
      idType: [],
      companyType: [
        {
          code: "CO",
          label: i18n.t("message.companyTypeCO"),
        },
        {
          code: "EM",
          label: i18n.t("message.companyTypeEM"),
        },
        {
          code: "SO",
          label: i18n.t("message.companyTypeSO"),
        },
      ],
      showAddressDialog: false,
    };
  },
  computed: {
    serviceType() {
      return this.$store.state.serviceType || "";
    },
    personalType() {
      return this.$store.state.personalType || "";
    },
    vssForm() {
      return this.$store.state.vssForm;
    },
    verifyForm() {
      return this.$store.state.verifyForm;
    },
    lan() {
      return this.$i18n.locale;
    },
  },
  methods: {
    // 子組件校驗，傳到父組件
    validateForm() {
      let flag = null;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
    // 打開澳門地址填寫彈窗
    onAddressFocus() {
      this.$refs["macauAddressInput"].blur();
      this.showAddressDialog = true;
    },
    // 儲存澳門地址回調
    saveMacauAddress(val) {
      // console.log(val);
      this.showAddressDialog = false;
      this.form.quota.macauAddress = val;
    },
    // 修改澳門地址
    changeVssMacauAddress(val) {
      if (val != "other") {
        // this.form.quota.macauAddress.textCn = val;
        const macauAddress = {
          textCn: val,
        };
        this.$set(this.form.quota, "macauAddress", macauAddress);
      }
    },
    // 獲取證件類別
    getIdentityTypes() {
      this.loading = true;
      VssViewAPI.getIdentityTypes()
        .then((res) => {
          this.loading = false;
          this.idType = res;
          this.$set(this.form.quota, "personIdentityType", "BM");
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 輸入字母轉大寫
    inputToUpperCase(val, name){
      this.form.quota[name] = val.toUpperCase();
    }
  },
  created() {
    // 獲取證件類別
    if (
      this.serviceType == "HZMB_FIRST_PERSON" ||
      this.serviceType == "HZMB_RENEW_PERSON"
    ) {
      this.getIdentityTypes();
    }
    // 根據申請類型設定驗證規則
    if (this.applicationType == "RENEW") {
      this.quotaRules.personIdentityType = [];
      this.quotaRules.personNameEn = [];
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-radio-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 100%;
  width: 100%;
  .el-radio {
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: pre-wrap;
    line-height: 22px;
  }
  .el-radio__label {
    font-size: 16px;
  }
  .el-radio__inner {
    width: 16px;
    height: 16px;
  }
}
</style>